import HandleMetricModalBlock from './handle-metric-modal.block';

export default HandleMetricModalBlock;
